import TextItalicIcon from '@atlaskit/icon/core/text-italic';
import * as React from 'react';

export function SvgItalics() {
  return <TextItalicIcon label="" testId="ads-refreshed-icon" />;
}
